import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppModal } from "@/shared/Components";
import type { FC, PropsWithChildren } from "react";
import type { ModalProps } from "antd/lib";
import type { ModalType } from "../types";
import styles from "./styles.module.scss";

interface Props extends ModalProps {
  modalTitle: string;
  type?: ModalType;
}

export const ModalWrapper: FC<PropsWithChildren<Props>> = ({
  modalTitle,
  children,
  className,
  okButtonProps,
  type,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <AppModal
      title={modalTitle}
      className={classNames(styles.modal, className)}
      okButtonProps={{
        className: classNames(styles[`btn-ok-${type}`]),
        ...okButtonProps,
      }}
      okText={type === "save" ? t("common.save") : t("common.delete")}
      cancelText={t("common.cancel")}
      closable={false}
      centered={true}
      {...props}
    >
      {children}
    </AppModal>
  );
};
